
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

@Injectable()
export class SpinnerService {

    constructor(private http: HttpClient) { }

    // Hide Spinner
    private _HideSpinner: boolean = true;
    public get hideSpinner(): boolean {
        return this._HideSpinner;
    }

    public set hideSpinner(value: boolean) {
        this._HideSpinner = value;
        this.observableHideSpinner.next(value);
    }    

    public observableHideSpinner = new Subject<boolean>();
    observableHideSpinnerStream$ = this.observableHideSpinner.asObservable();

    // Show Spinner
    private _ShowSpinner: boolean;
    public get showSpinner(): boolean {
        return this._ShowSpinner;
    }

    public set showSpinner(value: boolean) {
        this._ShowSpinner = value;
        this.observableShowSpinner.next(value);
    }

    public observableShowSpinner = new Subject<boolean>();
    observableShowSpinnerStream$ = this.observableShowSpinner.asObservable();
}
